<template>
  <div class="row q-col-gutter-xs items-center justify-end">
    <div class="col-md-auto">
      <slot name="top-actions"></slot>
    </div>
    <div class="col-md-auto">
      <q-select
        v-if="!hideColumnField"
        hide-bottom-space
        options-dense
        dense
        emit-value
        map-options
        outlined
        color="primary"
        :value="visibleColumns"
        :options="columns"
        option-value="name"
        multiple
        :label="$ts('labels.tableHideShowColumns')"
        :display-value="$q.lang.table.columns"
        option-disable="required"
        @input="value => $emit('update:visibleColumns', value)"
      >
        <template v-if="toggleView" v-slot:option="{ opt, selected, toggleOption }">
          <q-item>
            <q-item-section>
              <q-item-label v-html="opt.label"></q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-toggle color="secondary" :value="selected" @input="toggleOption(opt)" />
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <div class="col-md-auto">
      <q-select
        hide-bottom-space
        options-dense
        dense
        emit-value
        map-options
        outlined
        color="primary"
        :value="separator"
        :options="appSettings.defaulted.table_separators.options"
        :label="$ts('labels.tableLayoutStyles')"
        @input="value => $emit('update:separator', value)"
      />
    </div>
    <div class="col-md-auto">
      <q-btn
        flat
        round
        dense
        :icon="slotProps.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
        @click="
          slotProps.toggleFullscreen()
          $emit('fullscreenStatus', !slotProps.inFullscreen)
        "
      />
    </div>
    <div class="col-md-auto">
      <slot name="bottom-actions"></slot>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'QtableCustomSlotTopRight',
  props: {
    slotProps: {
      type: Object,
    },
    columns: {
      type: Array,
    },
    visibleColumns: {
      type: Array,
    },
    separator: {
      type: String,
    },
    toggleView: {
      type: Boolean,
      default: false,
    },
    hideColumnField: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      appSettings: state => state.globalCMP.appSettings,
    }),
  },
}
</script>
